// extracted by extract-css-chunks-webpack-plugin
module.exports = {"post_list":"ArticleList__post_list--1CaUP","empty_list_placeholder":"ArticleList__empty_list_placeholder--2uY_p"};